import * as React from 'react';
import { match } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { InformationCard } from './components/InformationCard';
import ViewButtons from '../share/ViewButtons/ViewButtons';
import { IAgency } from 'src/share/types/agency';
import { ICase } from 'src/share/types/case/case';
import './information.css'

export interface IInformationProps {
  agency: IAgency;
  caseData: ICase;
  history: any;
  loading: boolean;
  match: match<{ caseId: string }>
  permissionCase: boolean;
  isAnETLCase: boolean;
}

export default class Information extends React.Component<IInformationProps, any> {
  constructor(props: IInformationProps) {
    super(props);
  }
  public render() {
    return (
      <div className="case-information-content">
        <div className="help-loader">
          <BeatLoader loading={this.props.loading} />
        </div>
        {!this.props.loading && this.props.caseData && <InformationCard caseData={this.props.caseData} agencyName={this.props.agency.name} />}
        <ViewButtons
          history={this.props.history}
          match={this.props.match}
          caseData={this.props.caseData}
          loading={this.props.loading}
          permissionCase={this.props.permissionCase}
          isAnETLCase={this.props.isAnETLCase} />
      </div>
    );
  }
}
